import { render, staticRenderFns } from "./AssistantView.vue?vue&type=template&id=6127e07a&scoped=true&"
import script from "./AssistantView.vue?vue&type=script&lang=ts&"
export * from "./AssistantView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6127e07a",
  null
  
)

export default component.exports